import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Menu_Items from '../Menu_Items';
import { MdEditSquare } from "react-icons/md";

function Edit_company() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [inval, setinval] = useState({});

    const getcompany = async () => {
        await axios.get(`/company/Edit/${id}`).then((res) => {
            const { company, login } = res.data;
            const values = {
                name: company.name,
                code: company.code,
                mail: company.mail,
                mobile: company.mobile,
                no_integration: company.no_integration,
                uname: login.uname,
                password: login.password
            }
            setinval(values);
        }).catch((err) => {
            toast.error('Data Could not be Fetched', {
                autoClose: 2000, // 2 seconds
            });
        })
    };
    const handledata = (e) => {
        setinval({ ...inval, [e.target.id]: e.target.value });
    }
    const submit = async () => {
        await axios.patch(`/company/${id}`, inval).then((res) => {
            toast.success(res.data, {
                autoClose: 2000, // 2 seconds
            });
            navigate("/company");
        })
            .catch((err) => {
                toast.error("Can't Be Edit This Details", {
                    autoClose: 2000, // 2 seconds
                });
            });
    };
    useEffect(() => {
        getcompany();
    }, []);
    return (
        <>
            <div className='container df fdc jb ac'>
                <Navbar />
                <div className='main_box df'>
                    <Menu_Items />
                    <div className='content df fdc ac'>
                        <div className='page_header df ac'>
                            <div className='w90 df ac'><MdEditSquare className='page_icon db' />
                                <p>Edit Company</p></div>
                        </div>
                        <div className='box'>
                            <div className='create_box'>
                                <div className=''>
                                    <label htmlFor='name'>Company Name</label>
                                    <input type='search' id='name' value={inval.name ? inval.name : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                                <div>
                                    <label htmlFor='code'>Company Code</label>
                                    <input type='search' id='code' value={inval.code ? inval.code : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                                <div>
                                    <label htmlFor='mail'>E-Mail ID</label>
                                    <input type="search" id='mail' placeholder='Enter E-Mail ID' value={inval.mail ? inval.mail : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                                <div>
                                    <label htmlFor='mobile'>Mobile No</label>
                                    <input type="number" id='mobile' placeholder='Enter Mobile' value={inval.mobile ? inval.mobile : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                                <div>
                                    <label htmlFor='no_integration'>No Of Integration</label>
                                    <input type='number' id='no_integration' value={inval.no_integration ? inval.no_integration : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                                <div>
                                    <label htmlFor='uname'>User Name</label>
                                    <input type="search" id='uname' placeholder='Enter User Name' value={inval.uname ? inval.uname : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                                <div>
                                    <label htmlFor='password'>Password</label>
                                    <input type="search" id='password' placeholder='Enter Password' value={inval.password ? inval.password : ''} onChange={(e) => { handledata(e) }} />
                                </div>
                            </div>
                            <div className='w100 h10 df jc ac white'>
                                <button className='btn green' onClick={submit}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Edit_company;